/* Open the photo chooser from a product link while its click still has user activation. */
(() => {
  'use strict';
  const destination = '/pages/configuratore-foto';
  if (location.pathname === destination) return;

  const dbName = 'tp-direct-create';
  const storeName = 'handoffs';
  const productId = 15979180228942;
  let chooser;
  let busy = false;

  function openDb() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, 1);
      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(storeName)) {
          request.result.createObjectStore(storeName, { keyPath: 'id' });
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  async function save(record) {
    const db = await openDb();
    try {
      await new Promise((resolve, reject) => {
        const tx = db.transaction(storeName, 'readwrite');
        tx.objectStore(storeName).put(record);
        tx.oncomplete = resolve;
        tx.onerror = () => reject(tx.error);
        tx.onabort = () => reject(tx.error);
      });
    } finally {
      db.close();
    }
  }

  function getChooser() {
    if (chooser) return chooser;
    chooser = document.createElement('input');
    chooser.type = 'file';
    chooser.accept = 'image/jpeg,image/png,.jpg,.jpeg,.png';
    chooser.multiple = true;
    chooser.hidden = true;
    chooser.addEventListener('change', async () => {
      const files = Array.from(chooser.files || []);
      chooser.value = '';
      if (!files.length) return;
      if (files.length > 100 || files.some(file => !/\.(jpe?g|png)$/i.test(file.name) || file.size > 20 * 1024 * 1024)) {
        alert('Seleziona fino a 100 foto JPG o PNG, massimo 20 MB ciascuna.');
        return;
      }
      if (busy) return;
      busy = true;
      try {
        const id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        await save({
          id,
          createdAt: Date.now(),
          product: { id: productId, handle: 'stampa-foto-configuratore' },
          files: files.map(file => ({ name: file.name, type: file.type, lastModified: file.lastModified, blob: file }))
        });
        location.assign(`${destination}?tp_handoff=${encodeURIComponent(id)}`);
      } catch (error) {
        console.error('TP photo direct picker', error);
        alert('Non è stato possibile preparare le fotografie. Riprova.');
      } finally {
        busy = false;
      }
    });
    document.body.appendChild(chooser);
    return chooser;
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== destination || url.search || url.hash) return;
    event.preventDefault();
    getChooser().click();
  });
})();
